import {
  userForgotPassword,
  clearForgotPasswordOTP,
  userResetPassword,
} from "../../../Redux/Auth/AuthActions";
import { RootState, AppDispatch } from "../../../Redux/store";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../../Common/Loading/Loading";
import React, { useState, useEffect } from "react";
import styles from "./ForgotPassword.module.scss";
import validator from "../../../Util/validator";
import { FaRegEyeSlash } from "react-icons/fa6";
import { FaRegEye } from "react-icons/fa6";

interface Props {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

function ForgotPassword(props: Props) {
  const { setIsOpen } = props;
  const dispatch = useDispatch<AppDispatch>();
  const {
    forgotPasswordOTP,
    forgotPasswordOTPLoading,
    forgotPasswordOTPError,
    resetPasswordLoading,
  } = useSelector((state: RootState) => state.auth);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [otp, setOtp] = useState("");
  const [errors, setErrors] = useState<{
    email: string;
    password: string;
    confirmPassword: string;
    otp: string;
  }>({
    email: "",
    password: "",
    confirmPassword: "",
    otp: "",
  });

  const forgotPasswordHandler = (e: React.FormEvent) => {
    e.preventDefault();
    const { isValid, errors: fieldsErrors } = validator([
      {
        key: "email",
        value: email,
        type: "email",
      },
    ]);

    setErrors({ ...errors, ...fieldsErrors });
    if (isValid) {
      if (!forgotPasswordOTPLoading) {
        dispatch(userForgotPassword({ email }));
      }
    }
  };

  const resetPasswordHandler = (e: React.FormEvent) => {
    e.preventDefault();
    const { isValid, errors: fieldsErrors } = validator([
      { key: "otp", value: otp, type: "text" },
      {
        key: "password",
        value: password,
        type: "password",
      },
      {
        key: "confirmPassword",
        value: confirmPassword,
        type: "confirmPassword",
      },
    ]);
    setErrors({ ...errors, ...fieldsErrors });

    if (isValid) {
      if (!resetPasswordLoading) {
        const successHandler = () => {
          setIsOpen(false);
          setEmail("");
          setOtp("");
          setPassword("");
          setConfirmPassword("");
          // dispatch(clearForgotPasswordOTP());
        };

        dispatch(
          userResetPassword({
            email,
            otpCode: otp,
            newPassword: password,
            confirmPassword,
            successHandler,
          }),
        );
      }
    }
  };

  useEffect(() => {
    dispatch(clearForgotPasswordOTP());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={styles.mainContainer}>
      <div className={styles.headingContainer}>
        <h1 className={styles.heading}>Forgot Password</h1>
      </div>

      <div className={styles.mainBodyContainer}>
        {forgotPasswordOTPError && (
          <div className={styles.errorInformationContainer}>
            <p className={styles.information}>
              {forgotPasswordOTPError?.message}
            </p>
          </div>
        )}

        {forgotPasswordOTP && (
          <div className={styles.informationContainer}>
            <p className={styles.information}>{forgotPasswordOTP?.message}</p>
          </div>
        )}
        <div className={styles.formContainer}>
          <form className={styles.form}>
            {!forgotPasswordOTP && (
              <div className={styles.inputContainer}>
                <p className={styles.label}>Email</p>
                <input
                  className={styles.input}
                  type="email"
                  value={email}
                  autoComplete="email"
                  onChange={(e) => setEmail(e.target.value)}
                />
                <p className={styles.error}>{errors?.email}</p>
              </div>
            )}
            {forgotPasswordOTP && (
              <React.Fragment>
                <div className={styles.inputContainer}>
                  <p className={styles.label}>OTP</p>
                  <input
                    className={styles.input}
                    type="text"
                    value={otp}
                    autoComplete="otp"
                    onChange={(e) => setOtp(e.target.value)}
                  />
                  <p className={styles.error}>{errors?.otp}</p>
                </div>
                <div className={styles.inputContainer}>
                  <p className={styles.label}>Password</p>
                  <div className={styles.passwordInputContainer}>
                    <input
                      type={showPassword ? "text" : "password"}
                      className={styles.input}
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      autoComplete="current-password"
                    />
                    <button
                      type="button"
                      className={styles.showPasswordButton}
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      {showPassword ? (
                        <FaRegEyeSlash className={styles.icon} />
                      ) : (
                        <FaRegEye className={styles.icon} />
                      )}
                    </button>
                  </div>
                  <p className={styles.error}>{errors?.password}</p>
                </div>
                <div className={styles.inputContainer}>
                  <p className={styles.label}>Confirm Password</p>
                  <div className={styles.passwordInputContainer}>
                    <input
                      type={showConfirmPassword ? "text" : "password"}
                      className={styles.input}
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      autoComplete="current-password"
                    />
                    <button
                      type="button"
                      className={styles.showPasswordButton}
                      onClick={() =>
                        setShowConfirmPassword(!showConfirmPassword)
                      }
                    >
                      {showConfirmPassword ? (
                        <FaRegEyeSlash className={styles.icon} />
                      ) : (
                        <FaRegEye className={styles.icon} />
                      )}
                    </button>
                  </div>
                  <p className={styles.error}>{errors?.confirmPassword}</p>
                </div>
              </React.Fragment>
            )}

            {forgotPasswordOTPLoading && <Loading />}
            <div className={styles.formButtonContainer}>
              {!forgotPasswordOTP && (
                <button
                  className={styles.button}
                  onClick={forgotPasswordHandler}
                >
                  Send OTP
                </button>
              )}

              {forgotPasswordOTP && (
                <button
                  className={styles.button}
                  onClick={resetPasswordHandler}
                >
                  Save
                </button>
              )}
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
